import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"

class ModalConfirm extends Component {
    render() {
        const {isOpen, toggle, arrSelected, onDelete, loading, error} = this.props

        return (
            <div className='ModalConfirm'>
                <Modal isOpen={isOpen} toggle={this._toggle}>
                    <ModalHeader toggle={toggle}>Xóa sản phẩm</ModalHeader>
                    <ModalBody>
                        <div>
                            Bạn có chắc chắn muốn xóa <strong>{arrSelected.length}</strong> sản phẩm
                        </div>
                        {error && <span className='text-danger mt-3'>{error}</span>}
                    </ModalBody>
                    <ModalFooter className='d-flex justify-content-between align-items-center'>
                        <Button disabled={loading} color="secondary" onClick={toggle}>Hủy</Button>
                        <Button disabled={loading} color="primary" onClick={onDelete}>{loading &&
                        <i className='fa fa-spin fa-spinner mr-2'/>}Xóa</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

ModalConfirm.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    arrSelected: PropTypes.array,
    onDelete: PropTypes.func,
    loading: PropTypes.bool,
    error: PropTypes.string
}

export default ModalConfirm